import {useEffect} from "react"
import { useSelector, shallowEqual, useDispatch } from "react-redux"
import * as handlers from "../../../../../../_redux/selected-user/selectedUserHandlers";
import AccountLayoutSkeleton from "./AccountLayoutSkeleton";
import { Dropdown } from "react-bootstrap";
import {NavLink}  from "react-router-dom";
import {DropdownItemToggler, } from "../../../../../../../../../_metronic/_partials/dropdowns";
import {formatAmount, permissionCssClass} from "../../../../../../../../util/Helpers"
import {selectedUserSlice} from "../../../../../../_redux/selected-user/selectedUserSlice"
import { Permissions, PermissionType } from "../../../../../../../../util/Permissions";


const AccountLayout = props => {

    const adminUser = useSelector(state => state.auth.user);
    /* Get Account details from redux */
    const [accountDetails, notification] = useSelector(({selectedUser}) => {
        return [selectedUser.data?.accounts.filter(acc => acc.accountId === props.match.params.accountId)[0]?.details, selectedUser.notification];
    }, shallowEqual);

    // Redux dispatch
    const dispatch = useDispatch();
    const {actions: {toggleShowCreateAccountModal}} = selectedUserSlice;

    /* Fetch User Account Details on success notification */
    useEffect(() => {
        if (notification?.type === "success"){
            dispatch(handlers.fetchUserAccountDetails(props.match.params.userId, props.match.params.accountId));  
        }
    }, [dispatch, props.match.params.userId, props.match.params.accountId, notification]);

    /* Fetch User Account Details if not in redux */
    useEffect(() => {
        dispatch(handlers.fetchUserAccountDetails(props.match.params.userId, props.match.params.accountId));  
    }, [dispatch, props.match.params.userId, props.match.params.accountId, props.location.pathname]);

    const totalEquity = accountDetails?.positions.reduce((total, position) => total + position.equityBalance, 0);
    const marginMultiplier = Number(
        accountDetails?.portfolio?.user_configurations?.max_margin_multiplier
        ?? accountDetails?.portfolio?.multiplier
        ?? 1
    );
    const isMarginEnabled = Number.isFinite(marginMultiplier) && marginMultiplier > 1;

    return accountDetails ? <div>
                                <div className="card card-custom gutter-b">
                                    <div className="row p-8">
                                        {/* <!--begin::Field--> */}
                                        <div className="d-flex flex-column flex-grow-1 mt-0 pr-3 col-md">
                                            <span className="font-weight-bolder font-size-lg h5 text-primary">Market Value</span>
                                            <span className="text-muted font-weight-bold font-size-md my-1"> {formatAmount(accountDetails.currency, totalEquity)}</span>
                                        </div>
                                        {/* <!--begin::Field--> */}
                                        <div className="d-flex flex-column flex-grow-1 mt-0 pr-3 col-md">
                                            <span className="font-weight-bolder font-size-lg h5 text-primary">Cash Balance</span>
                                            <span className="text-muted font-weight-bold font-size-md my-1"> {formatAmount(accountDetails.currency, accountDetails.cashBalance)}</span>
                                        </div>
                                        {/* <!--begin::Field--> */}
                                        <div className="d-flex flex-column flex-grow-1 mt-0 pr-3 col-md">
                                            <span className="font-weight-bolder font-size-lg h5 text-primary">Total Value</span>
                                            <span className="text-muted font-weight-bold font-size-md my-1">{formatAmount(accountDetails.currency, totalEquity + accountDetails.cashBalance)}</span>
                                        </div>
                                        {/* <!--begin::Field--> */}
                                        <div className="d-flex flex-column flex-grow-1 mt-0 pr-3 col-md">
                                            <span className="font-weight-bolder font-size-lg h5 text-primary">Pending Settlement</span>
                                            <span className="text-muted font-weight-bold font-size-md my-1">{formatAmount(accountDetails.currency, accountDetails.pendingSettlementAmount)}</span>
                                        </div>
                                        {/* <!--begin::Field--> */}
                                        <div className="d-flex flex-column flex-grow-1 mt-0 pr-3 col-md">
                                            <span className="font-weight-bolder font-size-lg h5 text-primary">Trading Power</span>
                                            <span className="text-muted font-weight-bold font-size-md my-1">{formatAmount(accountDetails.currency, accountDetails.tradingPower)}</span>
                                        </div>
                                        {isMarginEnabled ? (
                                            <div className="d-flex flex-column flex-grow-1 mt-0 pr-3 col-md">
                                                <span className="font-weight-bolder font-size-lg h5 text-primary">Margin</span>
                                                <div className="my-1">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-success"
                                                    >
                                                        Margin Enabled
                                                    </button>
                                                </div>
                                            </div>
                                        ) : null}
                                        

                                        <Dropdown drop="down" alignRight>
                                            <Dropdown.Toggle
                                                as={DropdownItemToggler}
                                                id="kt_quick_actions_search_toggle"
                                            >
                                                
                                                <span
                                                    className="btn btn-icon btn-default btn-bg-white btn-hover-light-primary ml-2 h-40px w-40px flex-shrink-0"
                                                >
                                                    <i className="ki ki-bold-more-ver"></i>
                                                </span>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu className="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-md">
                                                
                                                <ul className="navi navi-hover py-5">
                                                    <li className={`navi-item ${permissionCssClass(adminUser, Permissions.ACCOUNTS, PermissionType.CREATE)}`}>
                                                        <span 
                                                            onClick={_ => dispatch(toggleShowCreateAccountModal())}
                                                            className="navi-link"
                                                            style={{cursor: "pointer"}}
                                                        >
                                                            <span className="navi-icon"><i className="flaticon2-shield"></i></span>
                                                            <span className="navi-text">New Trading Account</span>
                                                        </span>
                                                    </li>
                                                    <li className="navi-item d-none">
                                                        <NavLink to="/xx" className="navi-link">
                                                            <span className="navi-icon"><i className="flaticon2-user"></i></span>
                                                            <span className="navi-text">Something Else</span>
                                                        </NavLink>
                                                    </li>
                                                </ul>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        
                                        
                                    </div>
                                </div>

                                {props.children}
                                
                            </div>
    
                            :
                            
                            <AccountLayoutSkeleton/>

}

export default AccountLayout;
